module.exports = __webpack_public_path__ + "static/img/tn_2.6957b68.png";


//////////////////
// WEBPACK FOOTER
// ./static/mycard/character1/ワンダー系/tn_2.png
// module id = 960
// module chunks = 1